import styled from 'styled-components';

export * from './styled.shared';

export const TotalsRow = styled.div`
  display: flex;
`;
